import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

export interface EnrichmentPending {
  row_ids: number[];
  column_names: string[];
  cell_count: number;
}

export interface EnrichmentConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  pending: EnrichmentPending | null;
  onConfirm: () => void;
}

/**
 * Confirmation dialog shown before starting cell enrichment.
 * Displays the number of cells (rows × columns) that will be enriched.
 */
const EnrichmentConfirmationDialog: React.FC<
  EnrichmentConfirmationDialogProps
> = ({ open, onClose, pending, onConfirm }) => {
  const cellCount = pending?.cell_count ?? 0;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Enrich cells</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {pending
            ? `You are about to enrich ${cellCount} cell${cellCount === 1 ? '' : 's'}.`
            : 'No selection.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={(theme) => ({
            backgroundColor:
              theme.customColors?.themePrimary || theme.palette.primary.main,
            color: '#fff',
            '&:hover': {
              backgroundColor:
                theme.customColors?.themePrimary || theme.palette.primary.main,
              color: '#fff',
              filter: 'brightness(0.95)'
            }
          })}
        >
          Enrich
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnrichmentConfirmationDialog;
